import { Button } from "primereact/button"

import { useNavigate } from "react-router-dom"

const Logout = ()=>{
    const navigate = useNavigate()

    const handleLogout = (e) => {
        e.preventDefault()
        navigate('/login')
        localStorage.clear()
        
    }
    return (
        <Button onClick={handleLogout}>Logout</Button>
    )
}

export default Logout